type ListingPaginationControlsProps = {
  page: number;
  totalPages: number;
  onPageChange: (nextPage: number) => void;
  className?: string;
};

export function ListingPaginationControls({ page, totalPages, onPageChange, className }: ListingPaginationControlsProps) {
  if (totalPages <= 1) {
    return null;
  }

  const classes = ["listing-pagination", className].filter(Boolean).join(" ");

  return (
    <div className={classes}>
      <button type="button" className="nav-back-button" disabled={page <= 1} onClick={() => onPageChange(page - 1)}>
        <span className="nav-back-button__icon" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="presentation">
            <path d="M14.4 6.4L9 11.8l5.4 5.4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
        <span>Previous</span>
      </button>
      <span>Page {page} of {totalPages}</span>
      <button type="button" className="nav-back-button" disabled={page >= totalPages} onClick={() => onPageChange(page + 1)}>
        <span>Next</span>
        <span className="nav-back-button__icon nav-back-button__icon--next" aria-hidden="true">
          <svg viewBox="0 0 24 24" role="presentation">
            <path d="M14.4 6.4L9 11.8l5.4 5.4" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </span>
      </button>
    </div>
  );
}
